'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { useMemo as x } from "react";
import g from "./weight-loss-graph.module.scss.js";
import { Chart as k, CategoryScale as L, LinearScale as R, PointElement as S, LineElement as h, Title as z, Tooltip as E, Legend as N } from "../../external/chart.js/dist/chart.js";
import T from "../../external/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.esm.js";
import { Line as _ } from "../../external/react-chartjs-2/dist/index.js";
import { addPercentage as l } from "../../helpers/numberUtils.js";
import { formatWeight as $ } from "../../helpers/weightUtils.js";
k.register(
  L,
  R,
  S,
  h,
  z,
  E,
  N,
  T
);
const H = ({
  startWeight: o,
  halfwayMonth: n = 4,
  halfwayWeightPercentage: i = 5,
  endMonth: r = 12,
  endWeightPercentage: d = 10,
  style: y
}) => {
  const {
    headingColor: C,
    backgroundColor: p,
    labelBackgroundColor: m,
    labelTextColor: c,
    lineColor: u,
    pointColor: f
  } = y, j = x(() => {
    const a = l(o, -15), s = l(o, 5);
    return {
      maintainAspectRatio: !1,
      layout: {
        padding: {
          top: 32
        }
      },
      backgroundColor: p,
      scales: {
        x: {
          grid: {
            display: !1
          },
          border: {
            display: !1
          },
          offset: !0,
          ticks: {
            font: {
              size: 12,
              family: "MaisonNeue-Demi"
            },
            maxRotation: 0
          }
        },
        y: {
          min: a,
          max: s,
          grid: {
            display: !0,
            lineWidth: 1
          },
          border: {
            display: !1
          },
          ticks: {
            display: !1,
            stepSize: (s - a) / 5
          }
        }
      },
      plugins: {
        datalabels: {
          display: (t) => t.dataIndex % 2 === 0,
          formatter: (t) => `${t}kg`,
          backgroundColor: m,
          borderRadius: 4,
          padding: {
            top: 4,
            bottom: 4,
            left: 8,
            right: 8
          },
          labels: {
            title: {
              font: {
                weight: "bold",
                size: 16
              },
              color: c
            }
          },
          align: "top",
          offset: 12
        },
        legend: {
          display: !1
        },
        tooltip: {
          enabled: !1
        }
      }
    };
  }, [o, p, m, c]), b = x(() => ({
    labels: [
      "Start",
      "",
      `${n} months`,
      "",
      `${r} months`
    ],
    datasets: [
      {
        label: "Weight prediction",
        data: [
          o,
          // Extra points to make the line curve nicely
          l(
            o,
            -i + 1
          ),
          l(o, -i),
          l(
            o,
            -i - 1
          ),
          l(o, -d)
        ],
        borderColor: u,
        backgroundColor: f,
        pointRadius: 8,
        pointStyle: (s) => s.dataIndex % 2 === 0 ? "circle" : !1,
        // Curve the line
        tension: 0.3
      }
    ]
  }), [
    o,
    n,
    i,
    r,
    d,
    u,
    f
  ]);
  return b ? /* @__PURE__ */ e.jsxs("div", { className: g["weight-loss-graph"], children: [
    /* @__PURE__ */ e.jsx("h5", { children: "We predict that you could lose" }),
    /* @__PURE__ */ e.jsxs("h4", { style: { color: C }, children: [
      $(o - l(o, -10)),
      " in ",
      r,
      " months"
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: g.graph, children: /* @__PURE__ */ e.jsx(_, { options: j, data: b, height: 200 }) })
  ] }) : null;
};
export {
  H as default
};
